import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card, Dropdown, Button, Stack, Modal, CloseButton } from "react-bootstrap";
import { useState, useEffect } from "react";
import ListPSOProfilesTable from "Containers/Private/PSOProfile/List/ListPSOProfilesTable";
import { useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import { store } from 'Store';
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import { GetUserTextInputData, GetUserCheckboxInputData, GetUserDateInputData, GetUserPhoneInputData, GetUserSelectInputData, GetUserRadioInputData } from 'Containers/Private/Organization/Data files/UserFields';
import { GetTextInputData, GetCheckboxInputData, GetDateInputData, GetPhoneInputData, GetSelectInputData, GetRadioInputData, GetSelectInputObj } from 'Containers/Private/Organization/Data files/OrganizationFields';
import { ACTIONS, formInfoReducer } from 'Containers/Private/Organization/OrganizationFormDataReducer'
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import { Link, useNavigate } from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import DocumentTag from "Components/Documents/DocumentTag";
import DynamicPopup from "Components/Popup/DynamicPopup";
import DocumentPublicDownload from "Components/Documents/DocumentPublicDownload";


const ListPSOProfiles = () => {

    useEffect(() => {
        //localStorage.removeItem('backRedirect');
    }, []);


    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();

    const handleClose = () => {
        setShowPopup(false);
    };

    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);



    var dispatch = useDispatch();

    const loginState = store.getState().loginInfo;
    var [orgListData, setOrgListData] = useState(null);

    const setInitialSelectData = (dispatch, options) => {
        //console.log("setinitialselectdata", options);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            options: options
        })
    }

    //console.log(loginState);


    //const [status, setStatus] =  useState(passedStatusValue());
    //const passedOrg =  passedOrgValue(); 
    //const [currentOrgId,setCurrentOrgId] = useState(-1);

    const [isPSOAdmin, setIsPSOAdmin] = useState(null);
    const [isPSOPPCAdmin, setIsPSOPPCAdmin] = useState(null);
    const [allowEdit, setAllowEdit] = useState(null);
    const [isLoading, setIsLoading] = useState(true)
    const [getButtonInstruction, setGetButtonInstruction] = useState(null);

    var [orgList, orgListInputDispatch] = GetSelectInputObj({
        id: "select",
        name: "org",
        value: -1,
        options: [],
        label: "Select an Organization",
        description: "",
        title: "",
        placeholder: "",
        required: true,
        isInvalid: "",
        errors: "",
        isValid: false,
        successMsgs: [],
        disabled: "",
        readOnly: "",
        hideFieldOrgTypes: ""
    });

    var orgListValues = (orgList, selectedValue) => {
        //console.log(orgList);
        //console.log(selectedValue);
        var objArr = [];
        objArr.push({
            index: 0,
            value: -1,
            title: null,
            displayValue: "Select Organization",
            isSelected: selectedValue == null ? true : false
        });

        for (var i = 0; i < orgList.length; i++) {
            var x = orgList[i];
            //console.log(x);
            objArr.push({
                index: x.id,
                value: x.id,
                title: "Select organization " + x.name,
                displayValue: x.name + " (" + x.psoId + ")",
                isSelected: selectedValue == x.id ? true : false
            });
        }

        return objArr;
    };


    //console.log(loginState.token);


    //const handleOrgChange = () => {

    //}



    /*const loadOrgs = async () => {
      setIsLoading(true);
      const res = await http.post('api/manage/user/getorganizations', {
              headers: {
                  //"Authorization": "Bearer " + loginState.token
                  //"Referrer-Policy": "strict-origin-when-cross-origin"
              }
        }).then(res=>{
          
            //console.log("statuses");
            //console.log(res);
  
            if (res.status==1) {
                  //console.log("loadOrganizations ", res.data);
                  var d = res.data;
  
                  setOrgListData(d);
                  setInitialSelectData(orgListInputDispatch,orgListValues(d, -1));
  
  
                  //console.log(orgList);
                  //setIsPSOPPCAdmin(d.isPSOPPCAdmin);
                  //setIsPSOAdmin(d.isPSOAdmin);
                  //setAllowEdit(d.allow_edit);
            }
            else{
              
              setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                      visible: true, 
                      title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                      msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                      showContactHelp: true 
                  },
                  redirect: {
                      redirect: false, 
                      redirectFirst: false,
                      path: "", 
                      data:{}
                  }
              });
            }
            
        }).catch(function (error) {
  
  
             
              
  
  
  
              setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                      visible: true, 
                      title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                      msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                      showContactHelp: true 
                  },
                  redirect: {
                      redirect: false, 
                      redirectFirst: false,
                      path: "", 
                      data:{}
                  }
              });
              //console.log(error);
              //console.log("error caught from loadCompletedPSETestBatches()");
        });  
      };*/

    useEffect(() => {
        //setIsLoading(true);
        //loadOrgs().then(()=> {
        //setIsLoading(false);
        //});


    }, []);




    /*const handleInputSelectChange = (e) => {
        orgListInputDispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: ["error"]
        })
        //console.log("print out select change", e);
        //setCurrentOrgId(e.target.value);
    }*/

    const handleCreateUser = (e) => {
        //console.log(orgList);
        //console.log(orgListData);

        if (orgList.value != -1) {
            //console.log("HANDLE CREATE USER", e);
            var result = orgListData.find(obj => {
                return obj.id == orgList.value;
            });
            //console.log(result);
            var state = {
                psoId: result.psoId,
                orgName: result.name,
                orgId: result.id,
                orgTypeId: result.organizationTypeId,
                orgType: result.organizationType
            }
            var backRedirect = {
                path: location.pathname,
                state: JSON.parse(localStorage.getItem('state'))
            }
            localStorage.setItem('state', JSON.stringify(state));
            localStorage.setItem('backRedirect', JSON.stringify(backRedirect));

            navigate(
                "/manage/createUser"/*,
                { state: {
                    psoId: result.psoId,
                    orgName: result.name,
                    orgId: result.id,
                    orgTypeId: result.organizationTypeId,
                    orgType: result.organizationType

                }}*/
                /*
                    const psoId =  passedData.psoId;
                    const orgName =  passedData.orgName;
                    const organizationId =  passedData.orgId;
                    const orgTypeId =  24;
                */
            );

        }
        else {
            /*
                    isInvalid: action.errors != null ? true : false,
                    errors: action.errors
            */
            orgListInputDispatch({
                type: ACTIONS.SELECT_SET_ERRORS,
                errors: ["Please select a valid organization."]
            })
        }
    }

    const errorHandle = function () {
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true,
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                showContactHelp: true
            },
            redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
            }
        })
    };

    return (
        <Row >
            <Col xl={11} lg={11} md={11} sm={12}>
                <Card className="p-4" >
                    <Card.Body className="text-start">
                        <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Manage PSO Profile</h1>
                        <p>This online tool allows you to submit information for AHRQ's PSO Profile. Information regarding the PSO is entered first followed by summarized information for all provider organizations contracting with the PSO during the reporting year. You can download the current year form here:</p>
                        <div className="mt-2 mb-3">
                            <DocumentPublicDownload groupId={2855} pageName="manage PSO Profile" errorHandle={errorHandle} />
                        </div>

                        <p>Follow these instructions to ensure your PSO Profile is successfully submitted to the PSOPPC:</p>
                        <ul>
                            <li >Carefully read each question to ensure information for the appropriate period is provided.  The PSO Profile should reflect information from the previous calendar year, unless otherwise noted in the question.</li>
                            <li >Carefully review all definitions of terms provided to ensure all questions are answered accurately.</li>
                            <li >The PSO Profile is intended to be submitted to the PSOPPC between January 1st and February 28th of each year and can be updated as necessary thereafter.</li>
                            <li >Answer text is mandatory for all "please specify" answer selections.</li>
                        </ul>

                        {
                            getButtonInstruction != null
                                ? <div className="mb-4">{getButtonInstruction}</div>
                                : null
                        }

                        {/*

                                <!-- New PSO Profile button instruction-->
                                <c:if test="${allowCreate && !isCurrentYearProfileExisted }">
                                <p tabindex="0"><strong>Select the 'Add New PSO Profile' button to add Profile for the current reporting year.</strong></p>
                                </c:if>
                                
                                <!-- Carry Over PSO Profile from Last Year button instruction -->
                                <c:if test="${allowCreate && lastYrSubmittedProfileId != null && !isCurrentYearProfileExisted }">
                                <p tabindex="0"><strong>If a PSO Profile has been submitted last year, there is an opportunity to carry over the information, select the 'Carry over PSO Profile from last year' button.</strong></p>
                                </c:if>
                                
                                <!-- Update current year PSO Profile (Edit link) instruction-->
                                <c:if test="${allowCreate && isCurrentYearProfileExisted }">
                                <p tabindex="0"><strong>Select the 'Edit' link to update the current year PSO Profile.</strong></p>
                                </c:if>
                                
                                <!-- PSO Profile Feedback button instruction -->
                                <c:if test="${allowCreate && isPSO }">
                                    <p tabindex="0"><strong>Select the 'Profile Submission Feedback' button to enter your questions and feedbacks.</strong></p>
                                </c:if>




                                <span tabindex="0" class="msg-success" id="info" style="display: none;"></span>
                                <c:if test="${allowCreate && !isCurrentYearProfileExisted }">
                                    <input tabindex="0" type="submit" name="addNewPSOProfile" id="addNewPSOProfile" title="Click to Add New PSO Profile" value="Add New PSO Profile" class="dashboard" style="margin-right: 35px;" onclick="myForm.organizationId.value='${organizationId}'; myForm.action='${context}/managePSOProfile/addPSOProfiles';" />		
                                </c:if>
                                <c:if test="${allowCreate && lastYrSubmittedProfileId != null && !isCurrentYearProfileExisted }">
                                    <input tabindex="0" type="submit" name="addNewPSOProfile" id="addNewPSOProfile" title="Click to Carry over PSO Profile from last year" value="Carry over PSO Profile from last year" class="dashboard" style="margin-right: 35px;" onclick="myForm.profileId.value='${lastYrSubmittedProfileId}'; myForm.carryOverProfile.value='Yes';myForm.action='${context}/managePSOProfile/editPSOProfiles';" />		
                                </c:if>
                                <c:if test="${!isPSO }">
                                    <input tabindex="0" type="submit" name="PSOProfileReport" id="PSOProfileReport" title="Click here to generate and download the Profile Submission Summary Report" value="Profile Submission Summary Report" class="dashboard" onclick="myForm.action='${context}/runPSOProfileReport'"/>
                                </c:if>
                                <c:if test="${allowCreate && isPSO }">
                                    <input tabindex="0" type="submit" name="PSOProfileFeedback" id="fdbkDialog-link" title="Click to provide Profile Submission Feedback" value="Profile Submission Feedback" class="dashboard" style="margin-right: 25px; float: right;" onclick="">
                                <div class="clear"></div>
                                </c:if>
                            */}
                        <Row>
                            <Form>

                                {/*<FormInputDisplay fieldData={orgList} inputDispatch={orgListInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{is: true, labelCols: {lg:3}, inputCols: {lg:5}}}></FormInputDisplay>*/}


                                <Row>
                                    <Col>

                                        {/*<Tabs
                                                    id="organizationTabs"
                                                    activeKey={tab}
                                                    onSelect={(k) => handleTabChange(k)}
                                                    
                                                >
                                                    
                                                    <Tab eventKey="PSO" title="PSO">
                                                        */
                                                        /*tab === "PSO" &&  isPSOPPCAdmin==true*/

                                                        /*currentOrgId!=-1
                                                            ? */ <ListPSOProfilesTable getButtonInstruction={getButtonInstruction} setGetButtonInstruction={setGetButtonInstruction} setShowPopup={setShowPopup} orgType="PSO" info={{ allowEdit: allowEdit, isPSOPPCAdmin: isPSOPPCAdmin, isPSOAdmin: isPSOAdmin, isLoading: isLoading }} />

                                                            /*:""
                                                    /*
                                                    </Tab>
                                                
                                    </Tabs>*/}
                                    </Col>

                                </Row>

                            </Form>
                        </Row>

                    </Card.Body>
                </Card>
                {/*
                    <>
                        <Modal className="modal action" size="lg" backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
                            <Modal.Header>
                                <Modal.Title className="blue sem-bold">Select a PSO Organization</Modal.Title>
                                <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
                            </Modal.Header>
                            <Modal.Body>
                            <Stack direction="horizontal" className="popup-message action-message-body">
                                <div className="message w-100">
                                    <Form>
                                        
                                        <FormInputDisplay fieldData={orgList} inputDispatch={orgListInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={{is: false, labelCols: {lg:12}, inputCols: {lg:12}}}></FormInputDisplay>
                                        
                                    </Form>
                                </div>
                            </Stack>
                            </Modal.Body>
                            <Modal.Footer>
                            <Button onClick={handleCreateUser} variant="popup-confirm">
                                Continue
                            </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                                    */}
            </Col>
        </Row>
    )
}

export default ListPSOProfiles;